import { render, staticRenderFns } from "./giftedit.vue?vue&type=template&id=7e123ae5&scoped=true"
import script from "./giftedit.vue?vue&type=script&lang=js"
export * from "./giftedit.vue?vue&type=script&lang=js"
import style0 from "./giftedit.vue?vue&type=style&index=0&id=7e123ae5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e123ae5",
  null
  
)

export default component.exports